function buildWeeks(list) {
    let grouped = [],
        group;

    group = [];
    grouped.push(group);

    if (list !== null) {
        list.forEach(function (item, i) {
            if (i > 0 && i % 7 === 0) {
                group = [];
                grouped.push(group);
            }
            group.push(item);
        });
    }

    return grouped;
}

export default buildWeeks;